import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { useMemo } from "react"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  calculateCasilla33TotalBases,
  calculateCasilla34TotalCuotasDevengadas,
  calculateCasilla47TotalCuotasRecargoEquivalencia,
  calculateCasilla48,
  calculateCasilla49,
  calculateCasilla50,
  calculateCasilla51,
  calculateCasilla512,
  calculateCasilla513,
  calculateCasilla52,
  calculateCasilla520,
  calculateCasilla521,
  calculateCasilla53,
  calculateCasilla55,
  calculateCasilla56,
  calculateCasilla57,
  calculateCasilla58,
  calculateCasilla59,
  calculateCasilla597,
  calculateCasilla598,
  calculateCasilla64,
} from "../calculodeTotales"
import TemplateIvaDevengado from "./TemplateIvaDevengado"

const OperacionesRegimenGeneral = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()

  const casilla33 = useMemo(() => {
    const result = calculateCasilla33TotalBases(values)
    setValue("casilla33", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla700,
    values?.casilla667,
    values?.casilla01,
    values?.casilla702,
    values?.casilla03,
    values?.casilla05,
    values?.casilla704,
    values?.casilla671,
    values?.casilla500,
    values?.casilla706,
    values?.casilla502,
    values?.casilla504,
    values?.casilla708,
    values?.casilla675,
    values?.casilla643,
    values?.casilla710,
    values?.casilla645,
    values?.casilla647,
    values?.casilla712,
    values?.casilla679,
    values?.casilla07,
    values?.casilla714,
    values?.casilla09,
    values?.casilla11,
    values?.casilla13,
    values?.casilla716,
    values?.casilla683,
    values?.casilla21,
    values?.casilla718,
    values?.casilla23,
    values?.casilla25,
    values?.casilla720,
    values?.casilla687,
    values?.casilla545,
    values?.casilla722,
    values?.casilla547,
    values?.casilla551,
    values?.casilla27,
    values?.casilla29,
    values?.casilla649,
    values?.casilla31,
  ])

  const casilla34 = useMemo(() => {
    const result = calculateCasilla34TotalCuotasDevengadas(values)
    setValue("casilla34", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla701,
    values?.casilla668,
    values?.casilla02,
    values?.casilla703,
    values?.casilla04,
    values?.casilla06,
    values?.casilla705,
    values?.casilla672,
    values?.casilla501,
    values?.casilla707,
    values?.casilla503,
    values?.casilla505,
    values?.casilla709,
    values?.casilla676,
    values?.casilla644,
    values?.casilla711,
    values?.casilla646,
    values?.casilla648,
    values?.casilla713,
    values?.casilla680,
    values?.casilla08,
    values?.casilla715,
    values?.casilla10,
    values?.casilla12,
    values?.casilla14,
    values?.casilla717,
    values?.casilla684,
    values?.casilla22,
    values?.casilla719,
    values?.casilla24,
    values?.casilla26,
    values?.casilla721,
    values?.casilla688,
    values?.casilla546,
    values?.casilla723,
    values?.casilla548,
    values?.casilla552,
    values?.casilla28,
    values?.casilla30,
    values?.casilla650,
    values?.casilla32,
  ])

  const casilla47 = useMemo(() => {
    const result = calculateCasilla47TotalCuotasRecargoEquivalencia(values)
    setValue("casilla47", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values.casilla34,
    values.casilla664,
    values.casilla692,
    values.casilla36,
    values.casilla666,
    values.casilla694,
    values.casilla600,
    values.casilla602,
    values.casilla42,
    values.casilla44,
    values.casilla46,
  ])

  const fieldsGroupOne = [
    {
      label: "Régimen ordinario",
      columnOne: [
        {
          code: "casilla700",
          inputNumber: "700",
          value: values?.casilla700,
        },
        {
          code: "casilla667",
          inputNumber: "667",
          value: values?.casilla667,
        },
        {
          code: "casilla01",
          inputNumber: "01",
          value: values?.casilla01,
        },
        {
          code: "casilla702",
          inputNumber: "702",
          value: values?.casilla702,
        },
        {
          code: "casilla03",
          inputNumber: "03",
          value: values?.casilla03,
        },
        {
          code: "casilla05",
          inputNumber: "05",
          value: values?.casilla05,
        },
      ],
      columnTwo: [
        { value: 0, disabled: true },
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla701",
          inputNumber: "701",
          value: values?.casilla701,
          disabled: true,
        },
        {
          code: "casilla668",
          inputNumber: "668",
          value: values?.casilla668,
        },
        {
          code: "casilla02",
          inputNumber: "02",
          value: values?.casilla02,
        },
        {
          code: "casilla703",
          inputNumber: "703",
          value: values?.casilla703,
        },
        {
          code: "casilla04",
          inputNumber: "04",
          value: values?.casilla04,
        },
        {
          code: "casilla06",
          inputNumber: "06",
          value: values?.casilla06,
        },
      ],
    },
    {
      label: "Operaciones intragrupo",
      columnOne: [
        {
          code: "casilla704",
          inputNumber: "704",
          value: values?.casilla704,
          disabled: true,
        },
        {
          code: "casilla671",
          inputNumber: "671",
          value: values?.casilla671,
          disabled: true,
        },
        {
          code: "casilla500",
          inputNumber: "500",
          value: values?.casilla500,
          disabled: true,
        },
        {
          code: "casilla706",
          inputNumber: "706",
          value: values?.casilla706,
          disabled: true,
        },
        {
          code: "casilla502",
          inputNumber: "502",
          value: values?.casilla502,
          disabled: true,
        },
        {
          code: "casilla504",
          inputNumber: "504",
          value: values?.casilla504,
          disabled: true,
        },
      ],
      columnTwo: [
        { value: 0, disabled: true },
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla705",
          inputNumber: "705",
          value: values?.casilla705,
          disabled: true,
        },
        {
          code: "casilla672",
          inputNumber: "672",
          value: values?.casilla672,
          disabled: true,
        },
        {
          code: "casilla501",
          inputNumber: "501",
          value: values?.casilla501,
          disabled: true,
        },
        {
          code: "casilla707",
          inputNumber: "707",
          value: values?.casilla707,
          disabled: true,
        },
        {
          code: "casilla503",
          inputNumber: "503",
          value: values?.casilla503,
          disabled: true,
        },
        {
          code: "casilla505",
          inputNumber: "505",
          value: values?.casilla505,
          disabled: true,
        },
      ],
    },
    {
      label: "Régimen especial del criterio de caja",
      columnOne: [
        {
          code: "casilla708",
          inputNumber: "708",
          value: values?.casilla708,
        },
        {
          code: "casilla675",
          inputNumber: "675",
          value: values?.casilla675,
        },
        {
          code: "casilla643",
          inputNumber: "643",
          value: values?.casilla643,
        },
        {
          code: "casilla710",
          inputNumber: "710",
          value: values?.casilla710,
        },
        {
          code: "casilla645",
          inputNumber: "645",
          value: values?.casilla645,
        },
        {
          code: "casilla647",
          inputNumber: "647",
          value: values?.casilla647,
        },
      ],
      columnTwo: [
        { value: 0, disabled: true },
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla709",
          inputNumber: "709",
          value: values?.casilla709,
          disabled: true,
        },
        { code: "casilla676", inputNumber: "676", value: values?.casilla676 },
        { code: "casilla644", inputNumber: "644", value: values?.casilla644 },
        { code: "casilla711", inputNumber: "711", value: values?.casilla711 },
        { code: "casilla646", inputNumber: "646", value: values?.casilla646 },
        { code: "casilla648", inputNumber: "648", value: values?.casilla648 },
      ],
    },
    {
      label:
        "Régimen especial de bienes usados, objetos de arte, antigüedades y objetos de colección",
      columnOne: [
        {
          code: "casilla712",
          inputNumber: "712",
          value: values?.casilla712,
        },
        {
          code: "casilla679",
          inputNumber: "679",
          value: values?.casilla679,
          disabled: true,
        },
        {
          code: "casilla07",
          inputNumber: "07",
          value: values?.casilla07,
        },
        {
          code: "casilla714",
          inputNumber: "714",
          value: values?.casilla714,
          disabled: true,
        },
        {
          code: "casilla09",
          inputNumber: "09",
          value: values?.casilla09,
        },
        {
          code: "casilla11",
          inputNumber: "11",
          value: values?.casilla11,
        },
      ],
      columnTwo: [
        { value: 0, disabled: true },
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla713",
          inputNumber: "713",
          value: values?.casilla713,
          disabled: true,
        },
        {
          code: "casilla680",
          inputNumber: "680",
          value: values?.casilla680,
          disabled: true,
        },
        {
          code: "casilla08",
          inputNumber: "08",
          value: values?.casilla08,
        },
        {
          code: "casilla715",
          inputNumber: "715",
          value: values?.casilla715,
          disabled: true,
        },
        { code: "casilla10", inputNumber: "10", value: values?.casilla10 },
        { code: "casilla12", inputNumber: "12", value: values?.casilla12 },
      ],
    },
    {
      label: "Régimen especial de agencias de viaje",
      columnOne: [
        { code: "casilla13", inputNumber: "13", value: values?.casilla13 },
      ],
      columnTwo: [{ value: 21, disabled: true }],
      columnThree: [
        { code: "casilla14", inputNumber: "14", value: values?.casilla14 },
      ],
    },
    {
      label: "Adquisiciones intracomunitarias de bienes",
      columnOne: [
        { code: "casilla716", inputNumber: "716", value: 0 },
        { code: "casilla683", inputNumber: "683", value: 0 },
        {
          code: "casilla21",
          inputNumber: "21",
          value: values?.casilla21,
        },
        { code: "casilla718", inputNumber: "718", value: 0 },
        {
          code: "casilla23",
          inputNumber: "23",
          value: values?.casilla23,
        },
        {
          code: "casilla25",
          inputNumber: "25",
          value: values?.casilla25,
        },
      ],
      columnTwo: [
        { value: 0, disabled: true },
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla717",
          inputNumber: "717",
          value: values?.casilla717,
          disabled: true,
        },
        { code: "casilla684", inputNumber: "684", value: values?.casilla684 },
        {
          code: "casilla22",
          inputNumber: "22",
          value: values?.casilla22,
        },
        { code: "casilla719", inputNumber: "719", value: 0 },
        {
          code: "casilla24",
          inputNumber: "24",
          value: values?.casilla24,
        },
        {
          code: "casilla26",
          inputNumber: "26",
          value: values?.casilla26,
        },
      ],
    },

    {
      label: "Adquisiciones intracomunitarias de servicios",
      columnOne: [
        { code: "casilla720", inputNumber: "720", value: 0 },
        {
          code: "casilla687",
          inputNumber: "687",
          value: 0,
          disabled: true,
        },
        {
          code: "casilla545",
          inputNumber: "545",
          value: values?.casilla545,
        },
        {
          code: "casilla722",
          inputNumber: "722",
          value: 0,
          disabled: true,
        },
        {
          code: "casilla547",
          inputNumber: "547",
          value: values?.casilla547,
        },
        {
          code: "casilla551",
          inputNumber: "551",
          value: values?.casilla551,
        },
      ],
      columnTwo: [
        { value: 0, disabled: true },
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla721",
          inputNumber: "721",
          value: values?.casilla721,
          disabled: true,
        },
        {
          code: "casilla688",
          inputNumber: "688",
          value: values?.casilla688,
          disabled: true,
        },
        {
          code: "casilla546",
          inputNumber: "546",
          value: values?.casilla546,
        },
        {
          code: "casilla723",
          inputNumber: "723",
          value: values?.casilla723,
          disabled: true,
        },
        {
          code: "casilla548",
          inputNumber: "548",
          value: values?.casilla548,
        },
        {
          code: "casilla552",
          inputNumber: "552",
          value: values?.casilla552,
        },
      ],
    },
    {
      label: "IVA devengado en otros supuestos de inversión del sujeto pasivo",
      columnOne: [
        {
          code: "casilla27",
          inputNumber: "27",
          value: values?.casilla27,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla28",
          inputNumber: "28",
          value: values?.casilla28,
        },
      ],
    },

    {
      label: "Modificación de bases y cuotas",
      columnOne: [
        { code: "casilla29", inputNumber: "29", value: values?.casilla29 },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla30", inputNumber: "30", value: values?.casilla30 },
      ],
    },
    {
      label: "Modificación de bases y cuotas de operaciones intragrupo",
      columnOne: [
        { code: "casilla649", inputNumber: "649", value: values?.casilla649 },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla650", inputNumber: "650", value: values?.casilla650 },
      ],
    },
    {
      label:
        "Modificación de bases y cuotas por auto de declaración de concurso de acreedores",
      columnOne: [
        { code: "casilla31", inputNumber: "31", value: values?.casilla31 },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla32", inputNumber: "32", value: values?.casilla32 },
      ],
    },
    {
      label: "Total bases y cuotas IVA",
      columnOne: [
        {
          code: "casilla33",
          inputNumber: "33",
          value: values?.casilla33,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla34",
          inputNumber: "34",
          value: values?.casilla34,
          disabled: true,
        },
      ],
    },
  ]

  const fieldsGroupTwo = [
    {
      label: "Recargo de equivalencia",
      columnOne: [
        {
          code: "casilla663",
          inputNumber: "663",
          value: values?.casilla663,
        },
        {
          code: "casilla691",
          inputNumber: "691",
          value: values?.casilla691,
        },
        {
          code: "casilla35",
          inputNumber: "35",
          value: values?.casilla35,
        },
        {
          code: "casilla665",
          inputNumber: "665",
          value: values?.casilla665,
        },
        {
          code: "casilla693",
          inputNumber: "693",
          value: values?.casilla693,
        },
        {
          code: "casilla599",
          inputNumber: "599",
          value: values?.casilla599,
        },
        {
          code: "casilla601",
          inputNumber: "601",
          value: values?.casilla601,
        },
        {
          code: "casilla41",
          inputNumber: "41",
          value: values?.casilla41,
        },
      ],
      columnTwo: [
        { value: 0, disabled: true },
        { value: 0.26, disabled: true },
        { value: 0.5, disabled: true },
        { value: 0.62, disabled: true },
        { value: 1, disabled: true },
        { value: 1.4, disabled: true },
        { value: 5.2, disabled: true },
        { value: 1.75, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla664",
          inputNumber: "664",
          value: values?.casilla664,
          disabled: true,
        },
        {
          code: "casilla692",
          inputNumber: "692",
          value: values?.casilla692,
        },
        {
          code: "casilla36",
          inputNumber: "36",
          value: values?.casilla36,
        },
        {
          code: "casilla666",
          inputNumber: "666",
          value: values?.casilla666,
        },
        {
          code: "casilla694",
          inputNumber: "694",
          value: values?.casilla694,
        },
        {
          code: "casilla600",
          inputNumber: "600",
          value: values?.casilla600,
        },
        {
          code: "casilla602",
          inputNumber: "602",
          value: values?.casilla602,
        },
        {
          code: "casilla42",
          inputNumber: "42",
          value: values?.casilla42,
        },
      ],
    },
    {
      label: "Modificación recargo equivalencia",
      columnOne: [
        {
          code: "casilla43",
          inputNumber: "43",
          value: values?.casilla43,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla44",
          inputNumber: "44",
          value: values?.casilla44,
        },
      ],
    },
    {
      label:
        "Modificación recargo equivalencia por auto de declaración de concurso de acreedores",
      columnOne: [
        {
          code: "casilla45",
          inputNumber: "45",
          value: values?.casilla45,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla46",
          inputNumber: "46",
          value: values?.casilla46,
        },
      ],
    },
    {
      label:
        "Total cuotas IVA y recargo de equivalencia ([34] + [664] + [692] + [36] + [666] + [694] + [600] + [602] + [42] + [44] + [46])",
      columnOne: [],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla47",
          inputNumber: "47",
          value: values?.casilla47,
          disabled: true,
        },
      ],
    },
  ]

  const casilla48 = useMemo(() => {
    const result = calculateCasilla48(values)
    setValue("casilla48", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla695,
    values?.casilla190,
    values?.casilla724,
    values?.casilla603,
    values?.casilla605,
  ])

  const casilla49 = useMemo(() => {
    const result = calculateCasilla49(values)
    setValue("casilla49", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla696,
    values?.casilla191,
    values?.casilla725,
    values?.casilla604,
    values?.casilla606,
  ])

  const casilla512 = useMemo(() => {
    const result = calculateCasilla512(values)
    setValue("casilla512", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla745,
    values?.casilla506,
    values?.casilla726,
    values?.casilla607,
    values?.casilla609,
  ])

  const casilla513 = useMemo(() => {
    const result = calculateCasilla513(values)
    setValue("casilla513", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla746,
    values?.casilla507,
    values?.casilla727,
    values?.casilla608,
    values?.casilla610,
  ])

  const casilla50 = useMemo(() => {
    const result = calculateCasilla50(values)
    setValue("casilla50", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla749,
    values?.casilla196,
    values?.casilla728,
    values?.casilla611,
    values?.casilla613,
  ])

  const casilla51 = useMemo(() => {
    const result = calculateCasilla51(values)
    setValue("casilla51", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla750,
    values?.casilla197,
    values?.casilla729,
    values?.casilla612,
    values?.casilla614,
  ])

  const casilla520 = useMemo(() => {
    const result = calculateCasilla520(values)
    setValue("casilla520", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla753,
    values?.casilla514,
    values?.casilla730,
    values?.casilla615,
    values?.casilla617,
  ])

  const casilla521 = useMemo(() => {
    const result = calculateCasilla521(values)
    setValue("casilla521", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla753,
    values?.casilla514,
    values?.casilla730,
    values?.casilla615,
    values?.casilla617,
  ])

  const casilla52 = useMemo(() => {
    const result = calculateCasilla52(values)
    setValue("casilla52", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla757,
    values?.casilla202,
    values?.casilla732,
    values?.casilla619,
    values?.casilla621,
  ])

  const casilla53 = useMemo(() => {
    const result = calculateCasilla53(values)
    setValue("casilla53", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla758,
    values?.casilla203,
    values?.casilla733,
    values?.casilla620,
    values?.casilla622,
  ])

  const casilla54 = useMemo(() => {
    const result = calculateCasilla53(values)
    setValue("casilla53", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla761,
    values?.casilla208,
    values?.casilla734,
    values?.casilla623,
    values?.casilla625,
  ])

  const casilla55 = useMemo(() => {
    const result = calculateCasilla55(values)
    setValue("casilla55", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla762,
    values?.casilla209,
    values?.casilla735,
    values?.casilla624,
    values?.casilla626,
  ])

  const casilla56 = useMemo(() => {
    const result = calculateCasilla56(values)
    setValue("casilla56", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla765,
    values?.casilla214,
    values?.casilla736,
    values?.casilla627,
    values?.casilla629,
  ])

  const casilla57 = useMemo(() => {
    const result = calculateCasilla57(values)
    setValue("casilla57", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla766,
    values?.casilla215,
    values?.casilla737,
    values?.casilla628,
    values?.casilla630,
  ])

  const casilla58 = useMemo(() => {
    const result = calculateCasilla58(values)
    setValue("casilla58", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla769,
    values?.casilla220,
    values?.casilla738,
    values?.casilla631,
    values?.casilla633,
  ])

  const casilla59 = useMemo(() => {
    const result = calculateCasilla59(values)
    setValue("casilla59", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla770,
    values?.casilla221,
    values?.casilla739,
    values?.casilla632,
    values?.casilla634,
  ])

  const casilla597 = useMemo(() => {
    const result = calculateCasilla597(values)
    setValue("casilla597", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla773,
    values?.casilla587,
    values?.casilla740,
    values?.casilla635,
    values?.casilla637,
  ])

  const casilla598 = useMemo(() => {
    const result = calculateCasilla598(values)
    setValue("casilla598", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla774,
    values?.casilla587,
    values?.casilla741,
    values?.casilla636,
    values?.casilla638,
  ])

  const casilla64 = useMemo(() => {
    const result = calculateCasilla64(values)
    setValue("casilla64", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla49,
    values?.casilla513,
    values?.casilla51,
    values?.casilla521,
    values?.casilla53,
    values?.casilla55,
    values?.casilla57,
    values?.casilla59,
    values?.casilla598,
    values?.casilla61,
    values?.casilla661,
    values?.casilla62,
    values?.casilla652,
    values?.casilla63,
    values?.casilla522,
  ])

  const fieldsIvaDeducible = [
    {
      label:
        "Operaciones interiores corrientes: IVA deducible en operaciones interiores de bienes y servicios corrientes",
      columnOne: [
        {
          code: "casilla695",
          inputNumber: "695",
          value: values?.casilla695,
        },
        {
          code: "casilla190",
          inputNumber: "190",
          value: values?.casilla190,
        },
        {
          code: "casilla724",
          inputNumber: "724",
          value: values?.casilla724,
        },
        {
          code: "casilla603",
          inputNumber: "603",
          value: values?.casilla603,
        },
        {
          code: "casilla605",
          inputNumber: "605",
          value: values?.casilla605,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        { code: "casilla696", inputNumber: "696", value: 0 },
        { code: "casilla191", inputNumber: "191", value: 0 },
        { code: "casilla725", inputNumber: "725", value: 0 },
        { code: "casilla604", inputNumber: "604", value: 0 },
        { code: "casilla606", inputNumber: "606", value: 0 },
      ],
    },
    {
      label:
        "Total bases imponibles y cuotas deducibles en operaciones interiores de bienes y servicios corrientes",
      columnOne: [
        {
          code: "casilla48",
          inputNumber: "48",
          value: casilla48,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla49",
          inputNumber: "49",
          value: casilla49,
          disabled: true,
        },
      ],
    },
    {
      label:
        "IVA deducible en operaciones intragrupo de bienes y servicios corrientes",
      columnOne: [
        {
          code: "casilla745",
          inputNumber: "745",
          value: values?.casilla745,
        },
        {
          code: "casilla506",
          inputNumber: "506",
          value: values?.casilla506,
        },
        {
          code: "casilla726",
          inputNumber: "726",
          value: values?.casilla726,
        },
        {
          code: "casilla607",
          inputNumber: "607",
          value: values?.casilla607,
        },
        {
          code: "casilla609",
          inputNumber: "609",
          value: values?.casilla609,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        { code: "casilla746", inputNumber: "746", value: values?.casilla746 },
        { code: "casilla507", inputNumber: "507", value: values?.casilla507 },
        { code: "casilla727", inputNumber: "727", value: values?.casilla727 },
        { code: "casilla608", inputNumber: "608", value: values?.casilla608 },
        { code: "casilla610", inputNumber: "610", value: values?.casilla610 },
      ],
    },

    {
      label:
        "Total bases imponibles y cuotas deducibles en operaciones intragrupo de bienes y servicios corrientes",
      columnOne: [
        {
          code: "casilla512",
          inputNumber: "512",
          value: casilla512,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla513",
          inputNumber: "513",
          value: casilla513,
          disabled: true,
        },
      ],
    },
    {
      label:
        "Operaciones interiores de bienes de inversión: IVA deducible en operaciones interiores de bienes de inversión",
      columnOne: [
        {
          code: "casilla749",
          inputNumber: "749",
          value: values?.casilla749,
          disabled: true,
        },
        {
          code: "casilla196",
          inputNumber: "196",
          value: values?.casilla196,
        },
        {
          code: "casilla728",
          inputNumber: "728",
          value: values?.casilla728,
          disabled: true,
        },
        {
          code: "casilla611",
          inputNumber: "611",
          value: values?.casilla611,
        },
        {
          code: "casilla613",
          inputNumber: "613",
          value: values?.casilla613,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla750",
          inputNumber: "750",
          value: 0,
          disabled: true,
        },
        { code: "casilla197", inputNumber: "197", value: values?.casilla197 },
        {
          code: "casilla729",
          inputNumber: "729",
          value: 0,
          disabled: true,
        },
        { code: "casilla612", inputNumber: "612", value: values?.casilla612 },
        { code: "casilla614", inputNumber: "614", value: values?.casilla614 },
      ],
    },
    {
      label:
        "Total bases imponibles y cuotas deducibles en operaciones interiores de bienes de inversión",
      columnOne: [
        {
          code: "casilla50",
          inputNumber: "50",
          value: casilla50,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla51",
          inputNumber: "51",
          value: casilla51,
          disabled: true,
        },
      ],
    },
    {
      label: "IVA deducible en operaciones intragrupo de bienes de inversión",
      columnOne: [
        {
          code: "casilla753",
          inputNumber: "753",
          value: values?.casilla753,
          disabled: true,
        },
        {
          code: "casilla514",
          inputNumber: "514",
          value: values?.casilla514,
        },
        {
          code: "casilla730",
          inputNumber: "730",
          value: values?.casilla730,
          disabled: true,
        },
        {
          code: "casilla615",
          inputNumber: "615",
          value: values?.casilla615,
        },
        {
          code: "casilla617",
          inputNumber: "617",
          value: values?.casilla617,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla754",
          inputNumber: "754",
          value: 0,
          disabled: true,
        },
        { code: "casilla515", inputNumber: "515", value: values?.casilla515 },
        {
          code: "casilla731",
          inputNumber: "731",
          value: 0,
          disabled: true,
        },
        { code: "casilla616", inputNumber: "616", value: values?.casilla616 },
        { code: "casilla618", inputNumber: "618", value: values?.casilla618 },
      ],
    },
    {
      label:
        "Total bases imponibles y cuotas deducibles en operaciones intragrupo de bienes de inversión",
      columnOne: [
        {
          code: "casilla520",
          inputNumber: "520",
          value: casilla520,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla521",
          inputNumber: "521",
          value: casilla521,
          disabled: true,
        },
      ],
    },
    {
      label:
        "Importaciones y adquisiciones intracomunitarias de bienes y servicios: IVA deducible en importaciones de bienes corrientes",
      columnOne: [
        {
          code: "casilla757",
          inputNumber: "757",
          value: values?.casilla757,
        },
        {
          code: "casilla202",
          inputNumber: "202",
          value: values?.casilla202,
        },
        {
          code: "casilla732",
          inputNumber: "732",
          value: values?.casilla732,
        },
        {
          code: "casilla619",
          inputNumber: "619",
          value: values?.casilla619,
        },
        {
          code: "casilla621",
          inputNumber: "621",
          value: values?.casilla621,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        { code: "casilla758", inputNumber: "758", value: values?.casilla758 },
        { code: "casilla203", inputNumber: "203", value: values?.casilla203 },
        { code: "casilla733", inputNumber: "733", value: values?.casilla733 },
        { code: "casilla620", inputNumber: "620", value: values?.casilla620 },
        { code: "casilla622", inputNumber: "622", value: values?.casilla622 },
      ],
    },
    {
      label:
        "Total bases imponibles y cuotas deducibles en importaciones de bienes corrientes",
      columnOne: [
        {
          code: "casilla52",
          inputNumber: "52",
          value: casilla52,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla53",
          inputNumber: "53",
          value: casilla53,
          disabled: true,
        },
      ],
    },
    {
      label: "IVA deducible en importaciones de bienes de inversión",
      columnOne: [
        {
          code: "casilla761",
          inputNumber: "761",
          value: values?.casilla761,
          disabled: true,
        },
        {
          code: "casilla208",
          inputNumber: "208",
          value: values?.casilla208,
        },
        {
          code: "casilla734",
          inputNumber: "734",
          value: values?.casilla734,
          disabled: true,
        },
        {
          code: "casilla623",
          inputNumber: "623",
          value: values?.casilla623,
        },
        {
          code: "casilla625",
          inputNumber: "625",
          value: values?.casilla625,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla762",
          inputNumber: "762",
          value: values?.casilla762,
          disabled: true,
        },
        { code: "casilla209", inputNumber: "209", value: values?.casilla209 },
        {
          code: "casilla735",
          inputNumber: "735",
          value: values?.casilla735,
          disabled: true,
        },
        { code: "casilla624", inputNumber: "624", value: values?.casilla624 },
        { code: "casilla626", inputNumber: "626", value: values?.casilla626 },
      ],
    },

    {
      label:
        "Total bases imponibles y cuotas deducibles en importaciones de bienes de inversión",
      columnOne: [
        {
          code: "casilla54",
          inputNumber: "54",
          value: casilla54,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla55",
          inputNumber: "55",
          value: casilla55,
          disabled: true,
        },
      ],
    },
    {
      label:
        "IVA deducible en adquisiciones intracomunitarias de bienes corrientes",
      columnOne: [
        {
          code: "casilla765",
          inputNumber: "765",
          value: values?.casilla765,
        },
        {
          code: "casilla214",
          inputNumber: "214",
          value: values?.casilla214,
        },
        {
          code: "casilla736",
          inputNumber: "736",
          value: values?.casilla736,
        },
        {
          code: "casilla627",
          inputNumber: "627",
          value: values?.casilla627,
        },
        {
          code: "casilla629",
          inputNumber: "629",
          value: values?.casilla629,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        { code: "casilla766", inputNumber: "766", value: values?.casilla766 },
        { code: "casilla215", inputNumber: "215", value: values?.casilla215 },
        { code: "casilla737", inputNumber: "737", value: values?.casilla737 },
        { code: "casilla628", inputNumber: "628", value: values?.casilla628 },
        { code: "casilla630", inputNumber: "630", value: values?.casilla630 },
      ],
    },
    {
      label:
        "Total bases imponibles y cuotas deducibles en adquisiciones intracomunitarias de bienes corrientes",
      columnOne: [
        {
          code: "casilla56",
          inputNumber: "56",
          value: casilla56,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla57",
          inputNumber: "57",
          value: casilla57,
          disabled: true,
        },
      ],
    },
    {
      label:
        "IVA deducible en adquisiciones intracomunitarias de bienes de inversión",
      columnOne: [
        {
          code: "casilla769",
          inputNumber: "769",
          value: values?.casilla769,
          disabled: true,
        },
        {
          code: "casilla220",
          inputNumber: "220",
          value: values?.casilla220,
        },
        {
          code: "casilla738",
          inputNumber: "738",
          value: values?.casilla738,
          disabled: true,
        },
        {
          code: "casilla631",
          inputNumber: "631",
          value: values?.casilla631,
        },
        {
          code: "casilla633",
          inputNumber: "633",
          value: values?.casilla633,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla770",
          inputNumber: "770",
          value: values?.casilla770,
          disabled: true,
        },
        { code: "casilla221", inputNumber: "221", value: values?.casilla221 },
        {
          code: "casilla739",
          inputNumber: "739",
          value: values?.casilla739,
          disabled: true,
        },
        { code: "casilla632", inputNumber: "632", value: values?.casilla632 },
        { code: "casilla634", inputNumber: "634", value: values?.casilla634 },
      ],
    },

    {
      label:
        "Total bases imponibles y cuotas deducibles en adquisiciones intracomunitarias de bienes de inversión",
      columnOne: [
        {
          code: "casilla58",
          inputNumber: "58",
          value: casilla58,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla59",
          inputNumber: "59",
          value: casilla59,
          disabled: true,
        },
      ],
    },
    {
      label: "IVA deducible en adquisiciones intracomunitarias de servicios",
      columnOne: [
        {
          code: "casilla773",
          inputNumber: "773",
          value: values?.casilla773,
          disabled: true,
        },
        {
          code: "casilla587",
          inputNumber: "587",
          value: values?.casilla587,
        },
        {
          code: "casilla740",
          inputNumber: "740",
          value: values?.casilla740,
          disabled: true,
        },
        {
          code: "casilla635",
          inputNumber: "635",
          value: values?.casilla635,
        },
        {
          code: "casilla637",
          inputNumber: "637",
          value: values?.casilla637,
        },
      ],
      columnTwo: [
        { value: 2, disabled: true },
        { value: 4, disabled: true },
        { value: 5, disabled: true },
        { value: 10, disabled: true },
        { value: 21, disabled: true },
      ],
      columnThree: [
        {
          code: "casilla774",
          inputNumber: "774",
          value: values?.casilla774,
          disabled: true,
        },
        { code: "casilla588", inputNumber: "588", value: values?.casilla588 },
        {
          code: "casilla741",
          inputNumber: "741",
          value: values?.casilla741,
          disabled: true,
        },
        { code: "casilla636", inputNumber: "636", value: values?.casilla636 },
        { code: "casilla638", inputNumber: "638", value: values?.casilla638 },
      ],
    },
    {
      label:
        "Total bases imponibles y cuotas deducibles intracomunitarias de servicios",
      columnOne: [
        {
          code: "casilla597",
          inputNumber: "597",
          value: casilla597,
          disabled: true,
        },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla598",
          inputNumber: "598",
          value: casilla598,
          disabled: true,
        },
      ],
    },
    {
      label:
        "Compensación en régimen especial de la agricultura, ganadería y pesca",
      columnOne: [
        { code: "casilla60", inputNumber: "60", value: values?.casilla60 },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla61", inputNumber: "61", value: values?.casilla61 },
      ],
    },
    {
      label:
        "Cuotas deducibles en virtud de resolución administrativa o sentencia firmes con tipos no vigentes",
      columnOne: [
        { code: "casilla660", inputNumber: "660", value: values?.casilla660 },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla661", inputNumber: "661", value: values?.casilla661 },
      ],
    },
    {
      label: "Rectificación de deducciones",
      columnOne: [
        { code: "casilla639", inputNumber: "639", value: values?.casilla639 },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla62", inputNumber: "62", value: values?.casilla62 },
      ],
    },
    {
      label: "Rectificación de deducciones por operaciones intragrupo",
      columnOne: [
        { code: "casilla651", inputNumber: "651", value: values?.casilla651 },
      ],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla652", inputNumber: "652", value: values?.casilla652 },
      ],
    },
    {
      label: "Regularización de bienes de inversión",
      columnOne: [],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla63", inputNumber: "63", value: values?.casilla63 },
      ],
    },
    {
      label: "Regularización por aplicación porcentaje definitivo de prorrata",
      columnOne: [],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        { code: "casilla522", inputNumber: "522", value: values?.casilla522 },
      ],
    },
    {
      label:
        "Suma de deducciones ([49] + [513] + [51] + [521] + [53] + [55] + [57] + [59] + [598] + [61] + [661] + [62] + [652] + [63] + [522])",
      columnOne: [],
      columnTwo: [{ value: "-", disabled: true }],
      columnThree: [
        {
          code: "casilla64",
          inputNumber: "64",
          value: casilla64,
          disabled: true,
        },
      ],
    },
  ]

  const casilla65 = useMemo(() => {
    const casilla47 = values?.casilla47 ?? 0
    const casilla64 = values?.casilla64 ?? 0
    const result = casilla47 - casilla64
    setValue("casilla65", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.casilla47, values?.casilla64])

  return (
    <div
      title='OperacionesRegimenGeneral'
      className='tw-space-y-4 tw-w-full tw-px-4'
    >
      <div className='tw-font-medium'>
        {t("modelo390.operacionesRegimenGeneral.ivaDevengado")}
      </div>
      <TemplateIvaDevengado
        fields={fieldsGroupOne}
        setValue={setValue}
        watch={watch}
        calculateBaseImponible33={casilla33}
        calculateIvaDevengado34={casilla34}
      />
      <TemplateIvaDevengado
        fields={fieldsGroupTwo}
        setValue={setValue}
        watch={watch}
        calculateRecargoEquivalencia47={casilla47}
      />
      <div className='tw-font-medium'>
        {t("modelo390.operacionesRegimenGeneral.ivaDeducible")}
      </div>
      <TemplateIvaDevengado
        fields={fieldsIvaDeducible}
        isDeducible
        setValue={setValue}
        watch={watch}
      />
      <div className='tw-font-medium'>
        {t("modelo390.operacionesRegimenGeneral.result")}
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-[2fr_1fr_60px_1fr] tw-items-center tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3'>
        <div className='tw-text-sm tw-col-span-3'>
          {t("modelo390.operacionesRegimenGeneral.resultadoRegGeneral")}
        </div>
        <div className='tw-col-span-1'>
          <InputCurrencyGroup
            suffix='€'
            placeholder='0,00'
            className='tw-w-full tw-h-full tw-text-sm'
            numberGroup='65'
            value={casilla65}
            disabled
          />
        </div>
      </div>
    </div>
  )
}

export default OperacionesRegimenGeneral
